<template lang="pug">
  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
    thead.thead-light
      tr
        th.text-center(width="3%")
          span #
        th(width="10%" v-if="!isOperator")
          span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
        th(width="10%")
          span(:title="$t('ui.member_id')") {{ $t('ui.member_id') }}
        th(width="10%")
          span(:title="$t('ui.second_id')") {{ $t('ui.second_id') }}
        th(width="10%")
          span(:title="$t('ui.linkage')") {{ $t('ui.linkage') }}
        th.text-right(width="10%")
          span(:title="$t('ui.total_risk_score')") {{ $t('ui.total_risk_score') }}
    tbody.clusterize-content
      tr(v-if="tbl.length == 0")
        td(colspan="6").text-center
          span {{ $t('message.no_data_available') }}
      tr(v-for="(item, index) in tbl")
        td.text-center
          span(:title="index + 1") {{ index + 1 }}
        td(v-if="!isOperator")
          span(:title="item.parent_id") {{ item.parent_id }}
        td
          span(:title="item.member_id") {{ item.member_id }}
        td
          span(:title="item.second_id") {{ item.second_id }}
        td
          span(:title="item.linkage") {{ item.linkage }}
        td.text-right
          span(:title="item.total_risk_score") {{ item.total_risk_score }}
</template>
<script>
export default {
  props: {
    tbl: {
      type: Array,
      default() {
        return []
      }
    },
    tblId: {
      type: String,
      default: ""
    },
    isOperator: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    loading: false,
  }),
  mounted: function() {
  },
  methods: {
  }
};
</script>
